export type { TeamMemberFragment as TeamMember } from "../graphql/fragments.generated"

export const TeamMembersAPIType = "team_members" as const
export const UsersAPIType = "users" as const

export const TeamMemberTypename = "TeamMember" as const
